// Stores
import { useResult } from "../../../../shared/formContext/hooks/useResult";

// Components
import IconContent from '../../../../components/IconContent/IconContent.js';
import Cta from "../../../../components/Cta/Cta";
import Box from "../../../../components/Box/Box.js";
import Tabs from './../../../../components/Tabs/Tabs.js';
import ShareFullLink from "../../../../shared/components/ShareFullLink";

// Tabs
import TabAmortizacao from './../Tabs/TabAmortizacao';
// import TabTaxas from './../Tabs/TabTaxas';


// Helpers
import {utils} from "../../../../helpers/index.js";
import {__} from "@wordpress/i18n";

// Types
interface ResponseData {
    result: {
        monthly_payment: number;
        loan_last_payment_date: string;
        interest_total_cost: number;
        loan_total_cost: number;
    }
}

interface ResultStore {
    response: {
        data: ResponseData;
    } | null;
    loading: boolean;
}

const MortgagePayment: React.FC = () => {
    const { resultData } = useResult();
    const {response, loading}: ResultStore = resultData;

    return (
        <div className="calculadora-prestacao-de-credito-habitacao">
            {response && (
                <Box
                    grid
                    loading={loading}
                    header={{
                        title: __('A sua prestação mensal:', "df-simulators"),
                        info: utils.toEuro(response?.data?.result.monthly_payment),
                        color: 'orange-100',
                    }} backgroundColor={undefined} className={undefined} textColor={undefined}
                    vertical={undefined} collapsible={undefined} noPadding={undefined}
                >
                    <IconContent
                        title={__("Irá terminar de pagar o seu empréstimo em:", "df-simulators")}
                        color="orange-100"
                        bigText={utils.transformDate(response?.data?.result.loan_last_payment_date, false, false, '-')} icon={""} text={""}
                        textColor={""} className={""}/>
                    <IconContent
                        title={__("O custo total do seu empréstimo é de:", "df-simulators")}
                        color="orange-100"
                        bigText={utils.toEuro(response?.data?.result.interest_total_cost)} icon={""} text={""}
                        textColor={""} className={""}/>
                    <IconContent
                        title={__("A soma do custo e do capital é de:", "df-simulators")}
                        color="orange-100"
                        bigText={utils.toEuro(response?.data?.result.loan_total_cost)} icon={""} text={""}
                        textColor={""} className={""}/>
                </Box>
            )}

            <Tabs
                loading={loading}
                data={[
                    {
                        heading: __('Amortização', "df-simulators"),
                        content: <TabAmortizacao/>,
                    },
                    /*{
                        heading: 'Taxas de juro no mercado',
                        content: <TabTaxas/>,
                    },*/
                ]}
            />
            
            {/* Share Simulation button */}
            <ShareFullLink />

            {/* Call-to-Action - Standard project pattern */}
            <Cta/>
        </div>
    );
};

export default MortgagePayment;
